import { queryKeys } from '../keys'
import { DEFAULT_RETRY_MUTATION } from '../config'
import type { QueryClient } from '@tanstack/react-query'
import { asyncsService } from '@/services/asyncs'

function postAsyncsAmendCalculation(queryClient: QueryClient) {
  return queryClient.setMutationDefaults(queryKeys.asyncs.amendCalculation(), {
    retry: DEFAULT_RETRY_MUTATION,
    mutationFn: (
      params: Parameters<typeof asyncsService.amendCalculation>[0],
    ) => asyncsService.amendCalculation(params),
  })
}

export function registerAsyncsMutations(queryClient: QueryClient) {
  postAsyncsAmendCalculation(queryClient)
}
